import { zetApi } from '@zet/network'

export async function generateShareLinkToAddCustomer({ linkType, partnerId }) {
  let url = `/customer/generateShareLink/v2?linkType=${linkType}`
  if (partnerId) {
    url = `/customer/generateShareLink/v2?linkType=${linkType}&partnerId=${partnerId}`
  }
  const { data } = await zetApi.get(url)
  return data
}
